import { usePermissions } from "../../contexts/permissionProvider/PermissionsContext";

const Can = ({ headPermit, keyPermit, children }) => {
  const { permissions } = usePermissions();

  if (
    (permissions &&
      permissions[headPermit] &&
      permissions[headPermit][keyPermit]
    ) ||
    (permissions &&
      permissions["Full"] &&
      permissions["Full"]["full_permission"]
    )
  ) {
    return children;
  }

  return null;
};

export default Can;
